import { render, staticRenderFns } from "./projectCommentsTab.vue?vue&type=template&id=2000808d&scoped=true&"
import script from "./projectCommentsTab.vue?vue&type=script&lang=js&"
export * from "./projectCommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./projectCommentsTab.vue?vue&type=style&index=0&id=2000808d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000808d",
  null
  
)

export default component.exports